import _forIn from 'lodash/forIn';
import _forEach from 'lodash/forEach';
import _endsWith from 'lodash/endsWith';

/**
 * LocalStorageAdapter
 */
class LocalStorageAdapter {
  /**
   * Get the element 'key' in the store
   *
   * @param key
   * @return {*}
   */
  static get(key) {
    return localStorage.getItem(key);
  }

  /**
   * Set the element 'key' in the store to 'value'
   *
   * @param key
   * @param value
   * @param expires
   */
  static set(key, value, expires) { // eslint-disable-line no-unused-vars
    localStorage.setItem(key, value);
  }

  /**
   * Set element 'key' in the store to value, value must be json
   *
   * @param key
   * @param value
   * @param expires
   * @return {*}
   */
  static setJSON(key, value, expires) { // eslint-disable-line no-unused-vars
    localStorage.setItem(key, JSON.stringify(value));
  }

  /**
   * Get the element key in the store , it is supposed to be a JSON value.
   *
   * @param key
   * @return {*}
   */
  static getJSON(key) {
    const value = this.get(key);
    return JSON.parse(value);
  }

  /**
   * Remove element 'key' from storage
   *
   * @param key
   * @return {*}
   */
  static remove(key) {
    return localStorage.removeItem(key);
  }

  /**
   * Clear all the storage
   *
   * @return {*}
   */
  static clear() {
    return localStorage.clear();
  }

  /**
   * Delete all keys that are suffixed by the version
   */
  static removeByVersion(version) {
    const keysToDelete = [];

    _forIn(localStorage, (value, key) => {
      if (_endsWith(key, version)) {
        keysToDelete.push(key);
      }
    });

    _forEach(keysToDelete, (key) => {
      localStorage.removeItem(key);
    });
  }
}

export default LocalStorageAdapter;
